// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagRoadModel extends SmartTagModel {
	isWellMaintained?: boolean;
	maintainedType?: string;

	constructor() {
		super();
		this.isWellMaintained = false;
		this.maintainedType = '';
	}
}

export class SmartTagRoad extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagViewModel
	 */
	public render(data: SmartTagRoadModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v2');
	}

	private getData(data: SmartTagRoadModel): void {

		const title = data.title || data.subCategory || '';
		const isWellMaintained = data.isWellMaintained || '';
		const maintainedType = data.maintainedType || '';
		const description = data.description?.trim() || '';
		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}
		if (maintainedType !== '') {
			this.addText(`<span title="Road is used to access: ${maintainedType}">Road is used to access: ${maintainedType}</span>`);
		}
		if (isWellMaintained !== null) {
			this.addText(`<span title="Road is ${ !isWellMaintained ? 'NOT': ''} maintained">Road is ${ !isWellMaintained ? 'NOT': ''} maintained</span>`);
		}
		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}

}
